import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";
import SearchableDropdown from "../SearchableDropdown";
import { conceptos, buildDisplayName } from "../Utils";

const ModalCrud = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [isSearchingUser, setSearchingUser] = useState(false);
  const [userResult, setUserResult] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [dojos, setDojos] = useState([]);

  const [id, setId] = useState();
  const [user, setUser] = useState(null);
  const [concepto, setConcepto] = useState(null);
  const [month, setMonth] = useState(null);
  const [day, setDay] = useState(null);
  const [dojo, setDojo] = useState(null);

  const payment = props.payment;

  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    console.log({ payment });

    let dojosList = dojos;
    if (dojosList.length === 0) {
      dojosList = JSON.parse(ls.get("dojos"));
      setDojos(dojosList);
    }

    if (payment) {
      setId(payment.id);
      const c = conceptos.filter(
        (t) => t.id == payment.attributes.concepto[0].__component
      );
      setConcepto(c[0]?.id);

      setMonth(payment.attributes.concepto[0].month);
      setDay(payment.attributes.concepto[0].day);
      setDojo(payment.attributes.concepto[0].dojo?.data.id);

      console.log({ dojo });

      setUser({
        id: payment.attributes.alumno.data.id,
        value: buildDisplayName(payment.attributes.alumno.data.attributes),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return !concepto || concepto === "" || !user || user === "";
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  async function getUserByAny(value) {
    if (value && value.length > 3) {
      setSearchingUser(true);
      setErrorMessage(null);

      await axios
        .get(
          `${API_URL}/users/?filters[$or][0][docNumber][$startsWithi]=${value}&filters[$or][1][name][$startsWithi]=${value}&filters[$or][2][lastname][$startsWithi]=${value}`,
          headerRequest
        )
        .then((res) => {
          if (res.data) {
            const data = res.data.map(function (i) {
              return {
                id: i.id,
                value: buildDisplayName(i),
              };
            });
            setUserResult(data);
          }
        })
        .catch((error) => {
          console.log("Error find user:", error);
        })
        .finally(() => {
          setSearchingUser(false);
        });
    }
  }

  // TODO: grade
  function buildSaveConceptDetail(c) {
    let object = {};
    //console.log({ c });
    switch (c) {
      case "month-dojo.month-dojo":
        object = {
          __component: c,
          month,
          dojo,
        };
        break;
      case "day-dojo.day-dojo":
        object = {
          __component: c,
          day,
          dojo,
        };
        break;
      case "grade.grade":
        object = {
          __component: c,
          exam: null,
        };
        break;
    }
    return object;
  }

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    let request = {
      data: {
        alumno: user.id,
        concepto: [buildSaveConceptDetail(concepto)],
      },
    };
    console.log({ request });
    if (!id) {
      await axios
        .post(`${API_URL}/payments`, request, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post payments:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    } else {
      await axios
        .put(`${API_URL}/payments/${id}`, request, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put payments:", error.response);
          setErrorMessage(
            "Hubo un error, intente nuevamente. " +
              error.response.data.error.message
          );
          return;
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {payment ? "Editar" : "Crear"} Pago
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="formAlumno"
              className="has-feedback"
            >
              <Form.Label>Alumno</Form.Label>
              <SearchableDropdown
                options={userResult}
                label="value"
                id="id"
                selectedVal={user?.value}
                onChange={(e) => getUserByAny(e)}
                handleChange={(e) => setUser(e)}
              />
              {isSearchingUser ? (
                <span className="loading form-control-feedback"></span>
              ) : null}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formConcepto">
              <Form.Label>Concepto</Form.Label>
              <Form.Select
                value={concepto}
                onChange={(e) => setConcepto(e.target.value)}
              >
                <option key="0" value=""></option>
                {conceptos.map((i) => {
                  return (
                    <option key={i.id} value={i.id}>
                      {i.value}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Row>
          {concepto == "month-dojo.month-dojo" ||
          concepto == "day-dojo.day-dojo" ? (
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formDojo">
                <Form.Label>Dojo</Form.Label>
                <Form.Select
                  value={dojo}
                  onChange={(e) => setDojo(e.target.value)}
                >
                  <option>seleccione dojo</option>
                  {dojos
                    .filter((d) => d.attributes.endDate == null)
                    .map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.attributes.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </Form.Group>
            </Row>
          ) : null}

          {concepto == "month-dojo.month-dojo" ? (
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formMonth">
                <Form.Label>Mes</Form.Label>
                <Form.Control
                  type="date"
                  name="month"
                  min="2023-09"
                  max="2050-12"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                />
              </Form.Group>
            </Row>
          ) : null}

          {concepto == "day-dojo.day-dojo" ? (
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formDay">
                <Form.Label>Día</Form.Label>
                <Form.Control
                  type="date"
                  name="day"
                  min="2023-09-01"
                  max="2050-12-31"
                  value={day}
                  onChange={(e) => setDay(e.target.value)}
                />
              </Form.Group>
            </Row>
          ) : null}
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default ModalCrud;
